export const createTerminalsGraphqlQuery = (paging, sorting, filtering) => {
  const pagingString = `
    {
      ${Object.keys(paging).map(pagingKey => `${pagingKey}: ${paging[pagingKey]}`)}
    }
  `;

  const sortingString = `
    {
      ${Object.keys(sorting).map(sortingKey => `${sortingKey}: ${sorting[sortingKey]}`)}
    }
  `;

  const filteringString = `
    {
      ${Object.keys(filtering).map(filteringKey => `${filteringKey}: "${filtering[filteringKey]}"`)}
    }
  `;

  return `
    {
      terminals(
      paging: ${pagingString}
      sorting: ${sortingString}
      filtering: ${filteringString}
      ) {
        edges {
          cursor
          node {
            terminalId
            merchantId
            terminalDesignator
          }
        }
      }
    }
  `;
};
